<form [formGroup]="scheduleDetailsForm" *ngIf="scheduleDetailsForm">
    <div class="form-body-scrollable">
        <section class="tab-content-spacing k-d-grid k-gap-y-xl">
            <div class="k-d-flex k-gap-xl k-align-items-center" *ngIf="fieldVisibilityConfig.sessionType(this)">
                <kendo-svg-icon [icon]="chalkBordUser" size="medium"></kendo-svg-icon>
                <kendo-formfield class="k-w-full">
                    <kendo-label text="Session Type" labelCssClass="hidden-label">
                        <kendo-dropdownlist [data]="filteredSessionTypes" [valueField]="'id'"
                            [textField]="'description'" formControlName="sessionType"
                            [defaultItem]="defaultSessionTypeItem" [valuePrimitive]="true"
                            [disabled]="displayScheduleTimeButton && filteredSessionTypes?.length <= 1"></kendo-dropdownlist>
                    </kendo-label>
                </kendo-formfield>
            </div>
            <div class=" k-ml-10" *ngIf="fieldVisibilityConfig.trainingDescription(this)">
                <kendo-formfield class="k-w-full">
                    <kendo-label text="Training Description" labelCssClass="hidden-label">
                        <kendo-textbox placeholder="Training Description" formControlName="trainingDescription">
                        </kendo-textbox>
                    </kendo-label>
                </kendo-formfield>
            </div>

            <div class="k-d-flex k-gap-x-sm k-ml-10" *ngIf="fieldVisibilityConfig.sessionDetails(this)">
                <kendo-formfield class="k-w-full">
                    <!-- <kendo-label text="Provider Agency" labelCssClass="hidden-label">
                    <kendo-multiselect [valueField]="'id'" [textField]="'description'" formControlName="providerAgency"
                        [data]="providerAgencies">
                        <ng-template kendoPrefixTemplate>
                            <button kendoButton [disabled]="true">Provider Agency</button>
                        </ng-template>
                        <ng-template kendoMultiSelectTagTemplate let-dataItem>
                            <span class="template">{{ dataItem.name }}</span>
                        </ng-template>
                    </kendo-multiselect>
                </kendo-label> -->
                    <kendo-label text="Provider Agency" labelCssClass="hidden-label">
                        <kendo-dropdownlist formControlName="providerAgency" [data]="providerAgencies"
                            [valueField]="'id'" [disabled]="true" [textField]="'description'">
                            <ng-template kendoPrefixTemplate>
                                <button kendoButton [disabled]="true">Provider Agency</button>
                            </ng-template>
                        </kendo-dropdownlist>
                    </kendo-label>
                </kendo-formfield>
                <kendo-formfield class="k-w-full">
                    <kendo-label text="Service Type" labelCssClass="hidden-label">
                        <div class="input-with-validation" [class.has-error]="!checkValidServiceTypes">
                            <kendo-dropdownlist placeholder="Service Type" 
                            [data]="serviceTypeAgencies"
                                [valueField]="'id'" [textField]="'description'"
                                formControlName="serviceType"></kendo-dropdownlist>
                            <span class="validation-icon" *ngIf="showCrossMarks && showServiceTypes">
                                <span *ngIf="checkValidServiceTypes" class="validation-tooltip" 
                                    kendoTooltip title="Matches all associated mandates" tooltipPosition="top"
                                    showOn="click">
                                    <kendo-svg-icon [icon]="checkMark" size="small"
                                        class="k-text-success"></kendo-svg-icon>
                                </span>
                                <span *ngIf="!checkValidServiceTypes" class="validation-tooltip" 
                                    kendoTooltip title="Does not match service type of all associated mandates"
                                    tooltipPosition="top" showOn="click">
                                    <kendo-svg-icon [icon]="xMark" size="small" class="k-text-error"></kendo-svg-icon>
                                </span>
                            </span>
                        </div>
                    </kendo-label>
                </kendo-formfield>
                <kendo-formfield class="k-w-full">
                    <kendo-label text="Language" labelCssClass="hidden-label">
                        <!-- -->
                        <div class="input-with-validation" [class.has-error]="!checkValidLanguages">
                            <kendo-dropdownlist placeholder="Language" [data]="selectAllLanguages" [valueField]="'id'"
                                [textField]="'description'" formControlName="language"></kendo-dropdownlist>
                            <span class="validation-icon" *ngIf="showCrossMarks">
                                <span *ngIf="checkValidLanguages" class="validation-tooltip"  kendoTooltip
                                    title="Matches all associated mandates" tooltipPosition="top" showOn="click">
                                    <kendo-svg-icon [icon]="checkMark" size="small"
                                        class="k-text-success"></kendo-svg-icon>
                                </span>
                                <span *ngIf="!checkValidLanguages" class="validation-tooltip"  kendoTooltip
                                    title="Does not match language of all associated mandates" tooltipPosition="top"
                                    showOn="click">
                                    <kendo-svg-icon [icon]="xMark" size="small" class="k-text-error"></kendo-svg-icon>
                                </span>
                            </span>
                        </div>
                    </kendo-label>
                </kendo-formfield>
                <kendo-formfield class="k-w-full">
                    <kendo-label text="Group Size" labelCssClass="hidden-label">
                        <!-- [class.has-error]="!checkGroupeSize" -->
                        <div class="input-with-validation" [class.has-error]="!checkGroupeSize">

                            <kendo-textbox placeholder="Group Size" formControlName="groupSize" [inputAttributes]="{ 'aria-label': 'Group Size' }">
                                <ng-template kendoTextBoxPrefixTemplate>
                                    <button kendoButton [disabled]="true">Group
                                        Size</button>
                                </ng-template>
                            </kendo-textbox>
                            <span class="validation-icon" *ngIf="showGroupSizeCrossMarks">
                                <span *ngIf="checkGroupeSize" class="validation-tooltip"  kendoTooltip
                                    title="Matches all associated mandates" tooltipPosition="top" showOn="click">
                                    <kendo-svg-icon [icon]="checkMark" size="small"
                                        class="k-text-success"></kendo-svg-icon>
                                </span>
                                <span *ngIf="!checkGroupeSize" class="validation-tooltip"  kendoTooltip
                                    title="Group size is greater than at least one associated mandate's group size"
                                    tooltipPosition="top" showOn="click">
                                    <kendo-svg-icon [icon]="xMark" size="small" class="k-text-error"></kendo-svg-icon>
                                </span>
                            </span>
                        </div>
                    </kendo-label>
                    <kendo-formerror *ngIf="scheduleDetailsForm?.get('groupSize')?.hasError('required')">Error: Field is
                        required</kendo-formerror>
                </kendo-formfield>
            </div>
            <div class="k-ml-10" *ngIf="fieldVisibilityConfig.makeupSession(this)">
                <kendo-formfield>
                    <div class="k-form-field-checkbox-wrap">
                        <input type="checkbox" kendoCheckBox #meetingSession formControlName="makeupSession" />
                        <kendo-label class="k-checkbox-label" [for]="meetingSession"
                            text="This is a makeup session."></kendo-label>
                    </div>
                </kendo-formfield>
            </div>
        </section>
        <span class="k-form-separator !k-my-8" *ngIf="!showAbsencePeriodForCreate"></span>
        <section class="k-d-grid k-gap-y-xl"
            [class.time-spent-compact]="isTimeSpentSessionNotes || isProgressReportingSession"
            [class.absence-compact-section]="showAbsencePeriodForCreate"
            [style.rowGap.px]="showAbsencePeriodForCreate ? 0 : null">
            <div class="k-d-flex k-gap-xl k-align-items-center" *ngIf="fieldVisibilityConfig.dateTimeSection(this)">
                <kendo-svg-icon [icon]="clock" size="medium"></kendo-svg-icon>
                <div class="k-d-flex k-gap-x-sm k-align-items-center ">
                    <!-- [class.has-error]="!checkValidServiceStartDate" -->
                    <div class="k-d-flex input-with-validation2" [class.has-error]="!checkValidServiceStartDate"
                        [class.has-success]="checkValidServiceStartDate">

                        <kendo-formfield [style.width.px]="160">
                            <kendo-label text="Start Date" labelCssClass="hidden-label">
                                <kendo-datepicker calendarType="classic" placeholder="Start Date *"
                                    formControlName="startDate" [inputAttributes]="{ 'aria-label': 'Start Date' }">
                                </kendo-datepicker>
                            </kendo-label>
                            <kendo-formerror *ngIf="scheduleDetailsForm?.get('startDate')?.hasError('required')">Error:
                                Field is
                                required</kendo-formerror>
                        </kendo-formfield>

                        <!-- Validation Icon -->
                        <span class="validation-icon1  " *ngIf="showServiceStartDateCrossMarks">

                            <kendo-svg-icon *ngIf="checkValidServiceStartDate" [icon]="checkMark" size="small"
                                class="k-text-success" kendoTooltip title="Start date is valid" showOn="hover">
                            </kendo-svg-icon>

                            <kendo-svg-icon *ngIf="!checkValidServiceStartDate" [icon]="xMark" size="small"
                                class="k-text-error" kendoTooltip
                                title="Date is earlier than assignment start date for at least one associated mandate"
                                showOn="hover" tooltipPosition="top">
                            </kendo-svg-icon>

                        </span>
                    </div>


                    <kendo-formfield [style.width.px]="140" *ngIf="fieldVisibilityConfig.startTime(this)" [class.has-error]="!checkValidDuration"
                    [class.has-success]="checkValidDuration">
                        <kendo-label text="Start Time" labelCssClass="hidden-label">
                            <kendo-timepicker placeholder="Start Time*" [min]="shouldRestrictTime ? minTime() : null"
                                [max]="shouldRestrictTime ? maxTime() : endTimes" formControlName="startTime"
                                [class.k-invalid]="hasInvalidTimeRange" [inputAttributes]="{ 'aria-label': 'Start Time' }">
                            </kendo-timepicker>
                        </kendo-label>
                        <kendo-formerror *ngIf="scheduleDetailsForm?.get('startTime')?.hasError('required')">Error:
                            Field is
                            required</kendo-formerror>
                    </kendo-formfield>
                    <span class="k-d-flex k-align-items-center">to</span>
                    <kendo-formfield [style.width.px]="140" *ngIf="fieldVisibilityConfig.endTime(this)">
                        <kendo-label text="End Time" labelCssClass="hidden-label">
                            <kendo-timepicker placeholder="End Time*" formControlName="endTime" [inputAttributes]="{ 'aria-label': 'End Time' }"
                                [min]="shouldRestrictTime ? minTime() : startTimes"
                                [max]="shouldRestrictTime ? maxTime() : null" [class.k-invalid]="hasInvalidTimeRange">
                            </kendo-timepicker>
                        </kendo-label>
                        <kendo-formerror *ngIf="scheduleDetailsForm?.get('endTime')?.hasError('required')">Error:
                            Field is
                            required</kendo-formerror>
                    </kendo-formfield>
                    <!-- <span>{{duration}}</span> -->
                    <span>{{duration}}  <span class="validation-icon" *ngIf="showDurationCrossMarks && !hasServiceType3Or4">
                            <span *ngIf="checkValidDuration" class="validation-tooltip"  kendoTooltip
                                tooltipPosition="top" showOn="click">
                                <kendo-svg-icon [icon]="checkMark" size="small" class="k-text-success"></kendo-svg-icon>
                            </span>
                            <span *ngIf="!checkValidDuration" class="validation-tooltip"  kendoTooltip
                                title="Does not match duration of all associated mandates" tooltipPosition="top">
                                <kendo-svg-icon [icon]="xMark" size="small" class="k-text-error"></kendo-svg-icon>
                            </span>
                        </span></span>

                </div>
            </div>
            <div class="k-d-flex k-gap-xl k-align-items-center"
                *ngIf="showAbsencePeriodForCreate || fieldVisibilityConfig.occurencesSection(this)"
                [class.absence-compact-gap]="showAbsencePeriodForCreate">
                <kendo-svg-icon [icon]="repeat" size="medium"></kendo-svg-icon>
                <div class="k-d-flex k-gap-x-sm">
                    <kendo-formfield [style.width.px]="160"
                        *ngIf="showAbsencePeriodForCreate || fieldVisibilityConfig.occurences(this)">
                        <kendo-label text="Occurences" labelCssClass="hidden-label">
                            <kendo-dropdownlist [data]="referenceStore.occurences$ | async" [valueField]="'id'"
                                [textField]="'description'" formControlName="occurences"></kendo-dropdownlist>
                        </kendo-label>
                    </kendo-formfield>
                    <div class="k-d-flex k-gap-x-sm k-align-items-center">
                        <span class="k-d-flex k-align-items-center"
                            *ngIf="fieldVisibilityConfig.everyText(this)">every</span>
                        <kendo-formfield *ngIf="fieldVisibilityConfig.occurencesCount(this)">
                            <kendo-label class="k-display-block" text="Count" labelCssClass="hidden-label">
                                <kendo-numerictextbox [style.width.px]="80" [min]="1" [max]="30" [decimals]="0"
                                    format="##" formControlName="occurencesCount">
                                </kendo-numerictextbox>
                            </kendo-label>
                            <kendo-formerror
                                *ngIf="scheduleDetailsForm?.get('occurencesCount')?.hasError('required')">Error:
                                Field is
                                required</kendo-formerror>
                        </kendo-formfield>
                    </div>
                    <!----Articles according to occurences--->
                    <span class="k-d-flex k-align-items-center" *ngIf="fieldVisibilityConfig.daysText(this)">days</span>
                    <span class="k-d-flex k-align-items-center" *ngIf="fieldVisibilityConfig.weeksOnText(this)">weeks
                        on</span>
                    <span class="k-d-flex k-align-items-center" *ngIf="fieldVisibilityConfig.onText(this)">on</span>
                    <span class="k-d-flex k-align-items-center"
                        *ngIf="fieldVisibilityConfig.monthText(this)">month</span>
                    <span class="k-d-flex k-align-items-center" *ngIf="fieldVisibilityConfig.yearText(this)">year</span>
                    <!------Weekdays Chips------>
                    <div class="k-d-flex k-gap-x-sm k-align-items-center "
                        *ngIf="fieldVisibilityConfig.weekDayChip(this)"
                        [class.has-error]="scheduleDetailsForm.get('occurences')?.value?.id === occurencesEnum.EveryWeekday ? '' :showError">

                        <kendo-chiplist
                            [selection]="scheduleDetailsForm.get('occurences')?.value?.id === occurencesEnum.EveryWeekday ? 'none' : 'multiple'"
                            (selectedChange)="selectedWeekChipChange($event)" [navigable]="true">
                            <kendo-chip *ngFor="let weekDay of referenceStore.weekDays$ | async" class="kendo-chip chip"
                                size="large" rounded="medium" fillMode="solid" themeColor="base" [removable]="false"
                                [selected]="scheduleDetailsForm.get('weekDayChip')?.value?.includes(weekDay.id)">
                                {{weekDay.value}}
                            </kendo-chip>
                        </kendo-chiplist>
                    </div>
                    <!---Month on Day---->
                    <div class="k-d-flex k-gap-x-sm" *ngIf="fieldVisibilityConfig.monthOnGroup(this)">
                        <kendo-formfield>
                            <li class="k-radio-item">
                                <input type="radio" [value]="'onDay'" #monthOn kendoRadioButton
                                    formControlName="monthlyOption" />
                                <kendo-label class="k-radio-label" [for]="monthOn" text="On Day">
                                </kendo-label>
                            </li>
                        </kendo-formfield>
                        <kendo-formfield>
                            <kendo-label class="k-display-block" text="Count" labelCssClass="hidden-label">
                                <kendo-numerictextbox [style.width.px]="80" [min]="1" [max]="30" [decimals]="0"
                                    format="##" formControlName="dayCount">
                                </kendo-numerictextbox>
                            </kendo-label>
                        </kendo-formfield>
                    </div>
                    <!---Year on---->
                    <div class="k-d-flex k-gap-x-sm" *ngIf="fieldVisibilityConfig.yearlyOnGroup(this)">
                        <kendo-formfield>
                            <li class="k-radio-item">
                                <input type="radio" [value]="'yearOn'" #yearlyOn kendoRadioButton
                                    formControlName="yearlyOption" />
                                <kendo-label class="k-radio-label" [for]="yearlyOn" text="On">
                                </kendo-label>
                            </li>
                        </kendo-formfield>
                        <kendo-formfield [style.width.px]="140">
                            <kendo-label text="Month Of Year" labelCssClass="hidden-label">
                                <kendo-dropdownlist formControlName="monthOfYear"
                                    [data]="referenceStore.months$ | async" [valueField]="'id'"
                                    [textField]="'description'"></kendo-dropdownlist>
                            </kendo-label>
                        </kendo-formfield>
                        <kendo-formfield>
                            <kendo-label class="k-display-block" text="Day Of Month" labelCssClass="hidden-label">
                                <kendo-numerictextbox [style.width.px]="80" [min]="1" [max]="30" [decimals]="0"
                                    format="##" formControlName="dayCount">
                                </kendo-numerictextbox>
                            </kendo-label>
                        </kendo-formfield>
                    </div>
                </div>
            </div>
            <!---Month On The----->
            <div class="k-d-flex k-gap-x-sm k-align-items-center" style="margin-left:390px"
                *ngIf="fieldVisibilityConfig.monthOnTheGroup(this)">
                <kendo-formfield>
                    <li class="k-radio-item k-mt-2">
                        <input type="radio" [value]="'onThe'" #monthOnThe kendoRadioButton
                            formControlName="monthlyOption" />
                        <kendo-label class="k-radio-label" [for]="monthOnThe" text="On The">
                        </kendo-label>
                    </li>
                </kendo-formfield>
                <kendo-formfield [style.width.px]="110">
                    <kendo-label text="Week Order" labelCssClass="hidden-label">
                        <kendo-dropdownlist formControlName="weekOrder" [data]="referenceStore.weekOrder$ | async"
                            [valueField]="'id'" [textField]="'description'"></kendo-dropdownlist>
                    </kendo-label>
                </kendo-formfield>
                <kendo-formfield [style.width.px]="140">
                    <kendo-label text="Week Day" labelCssClass="hidden-label">
                        <kendo-dropdownlist formControlName="weekDay" [data]="referenceStore.weekDays$ | async"
                            [valueField]="'id'" [textField]="'description'"></kendo-dropdownlist>
                    </kendo-label>
                </kendo-formfield>
            </div>
            <!---Year On The----->
            <div class="k-d-flex k-gap-x-sm k-align-items-center" style="margin-left:340px"
                *ngIf="fieldVisibilityConfig.yearlyOnTheGroup(this)">
                <kendo-formfield>
                    <li class="k-radio-item k-mt-2">
                        <input type="radio" [value]="'yearOnThe'" #yearlyOnThe kendoRadioButton
                            formControlName="yearlyOption" />
                        <kendo-label class="k-radio-label" [for]="yearlyOnThe" text="On The">
                        </kendo-label>
                    </li>
                </kendo-formfield>
                <kendo-formfield [style.width.px]="110">
                    <kendo-label text="Week Order" labelCssClass="hidden-label">
                        <kendo-dropdownlist formControlName="weekOrder" [data]="referenceStore.weekOrder$ | async"
                            [valueField]="'id'" [textField]="'description'"></kendo-dropdownlist>
                    </kendo-label>
                </kendo-formfield>
                <kendo-formfield [style.width.px]="140">
                    <kendo-label text="Month Of Year" labelCssClass="hidden-label">
                        <kendo-dropdownlist formControlName="weekDay" [data]="referenceStore.weekDays$ | async"
                            [valueField]="'id'" [textField]="'description'"></kendo-dropdownlist>
                    </kendo-label>
                </kendo-formfield>
                <span class="k-d-flex k-align-items-center">of</span>
                <kendo-formfield [style.width.px]="140">
                    <kendo-label text="Month Of Year Alt" labelCssClass="hidden-label">
                        <kendo-dropdownlist formControlName="monthOfYearAlt" [data]="referenceStore.months$ | async"
                            [valueField]="'id'" [textField]="'description'"></kendo-dropdownlist>
                    </kendo-label>
                </kendo-formfield>
            </div>
            <!----Repeat Until--->
            <div class="k-ml-10 k-d-flex k-gap-sm k-align-items-center"
                *ngIf="fieldVisibilityConfig.repeatUntilSection(this)">
                <kendo-formfield [style.width.px]="160" class="k-display-block">
                    <kendo-label text="Repeat Until" labelCssClass="hidden-label">
                        <kendo-dropdownlist [data]="referenceStore.repeatUntil$ | async" [itemDisabled]="itemDisabled"
                            [valueField]="'id'" [textField]="'description'"
                            formControlName="repeatUntil"></kendo-dropdownlist>
                    </kendo-label>
                    <kendo-formerror *ngIf="scheduleDetailsForm?.get('repeatUntil')?.hasError('required')">Error:
                        Field is
                        required</kendo-formerror>
                </kendo-formfield>
                <kendo-formfield [style.width.px]="80" *ngIf="fieldVisibilityConfig.repeatUntilCount(this)">
                    <kendo-label class="k-display-block" text="Count" labelCssClass="hidden-label">
                        <kendo-numerictextbox [min]="1" [max]="30" [decimals]="0" format="##"
                            formControlName="repeatUntilCount">
                        </kendo-numerictextbox>
                    </kendo-label>
                </kendo-formfield>
                <span class="k-d-flex k-align-items-center"
                    *ngIf="fieldVisibilityConfig.occurencesText(this)">occurrences</span>
                <!-- -->
                <div class="k-d-flex input-with-validation2" [class.has-error]="!checkAssignmentEndDate">
                    <kendo-formfield [style.width.px]="160" *ngIf="fieldVisibilityConfig.endByDate(this)">
                        <kendo-label text="End By Date" labelCssClass="hidden-label">
                            <kendo-datepicker calendarType="classic" placeholder="End By Date"
                                formControlName="endByDate"
                                [min]="scheduleDetailsForm?.value?.startDate"></kendo-datepicker>
                        </kendo-label>
                        <kendo-formerror *ngIf="scheduleDetailsForm?.get('endByDate')?.hasError('required')">Error:
                            Field is
                            required</kendo-formerror>
                    </kendo-formfield>
                    <span class="validation-icon1" *ngIf="showEndByDateCrossMarks">
                        <span *ngIf="checkAssignmentEndDate" class="validation-tooltip"  kendoTooltip
                            tooltipPosition="top" showOn="hover">
                            <kendo-svg-icon [icon]="checkMark" size="small" class="k-text-success"></kendo-svg-icon>
                        </span>
                        <span *ngIf="!checkAssignmentEndDate" class="validation-tooltip"  kendoTooltip
                            title="Date is later than assignment end date for at least one associated mandate"
                            tooltipPosition="top" showOn="hover">
                            <kendo-svg-icon [icon]="xMark" size="small" class="k-text-error"></kendo-svg-icon>
                        </span>
                    </span>
                </div>

            </div>
            <!-------------Student/ Mandates------->
            <div class="k-d-flex k-gap-xl k-align-items-center" *ngIf="fieldVisibilityConfig.mandates(this)">
                <kendo-svg-icon [icon]="users" size="medium"></kendo-svg-icon>
                <kendo-formfield class="k-w-full">
                    <kendo-label text="Students/Mandates" labelCssClass="hidden-label">
                        <div class="input-with-validation">

                            <kendo-multiselect placeholder="Students/Mandates" formControlName="studentMandates"
                                (open)="onOpen($event)" [inputAttributes]="{ 'aria-label': 'Students/Mandates' }">
                                <ng-template kendoPrefixTemplate>
                                    <button kendoButton [disabled]="true">Students/Mandates</button>
                                </ng-template>
                                <ng-template kendoMultiSelectTagTemplate let-dataItem>
                                    <span class="template">{{ dataItem.studentName }}</span> ({{
                                    dataItem.mandateDescription
                                    }})
                                </ng-template>
                            </kendo-multiselect>
                            <span class="validation-icon" *ngIf="showCrossMandateMarks">
                                <span *ngIf="checkValidGradeorAge" class="validation-tooltip"  kendoTooltip
                                    tooltipPosition="top" showOn="click">
                                    <kendo-svg-icon [icon]="checkMark" size="small"
                                        class="k-text-success"></kendo-svg-icon>
                                </span>
                                <span *ngIf="!checkValidGradeorAge" class="validation-tooltip"  kendoTooltip
                                    title="At lease one assignment is not valid or Grade range of group is greater than 3 or Age range of group is greater than 36 months"
                                    tooltipPosition="top" showOn="click">
                                    <kendo-svg-icon [icon]="xMark" size="small" class="k-text-error"></kendo-svg-icon>
                                </span>
                            </span>
                            <!-- <span class="validation-icon">
                            <span *ngIf="getFieldValidation('studentMandates')?.status === 'ok'"
                                class="validation-tooltip" tabindex="0" kendoTooltip
                                title="{{ getFieldValidation('studentMandates')?.message || 'At least one assignment is valid' }}"
                                tooltipPosition="top" showOn="click">
                                <kendo-svg-icon [icon]="checkMark" size="small" class="k-text-success"></kendo-svg-icon>
                            </span>
                            <span *ngIf="getFieldValidation('studentMandates')?.status === 'error'"
                                class="validation-tooltip" tabindex="0" kendoTooltip
                                title="{{ getFieldValidation('studentMandates')?.message || 'No valid assignment for selected mandates' }}"
                                tooltipPosition="top" showOn="click">
                                <kendo-svg-icon [icon]="xMark" size="small" class="k-text-error"></kendo-svg-icon>
                            </span>
                        </span> -->
                        </div>
                    </kendo-label>
                </kendo-formfield>
            </div>
            <!-----------Participants------------>
            <div class="k-d-flex k-gap-xl k-align-items-start">
                <kendo-svg-icon [icon]="users" size="medium" *ngIf="fieldVisibilityConfig.students(this)
                     || fieldVisibilityConfig.requiredAttendees(this) 
                     || fieldVisibilityConfig.optionalAttendees(this)|| 
                     fieldVisibilityConfig.studentsIepMeeting(this)">
                </kendo-svg-icon>

                <div class="k-d-grid k-gap-y-md k-flex-1">
                    <kendo-formfield class="k-w-full" *ngIf="fieldVisibilityConfig.students(this)">
                        <kendo-label text="Students" labelCssClass="hidden-label">
                            <kendo-multiselect formControlName="students" [data]="studentList" textField="studentName"
                                valueField="nycId" [filterable]="true" [allowCustom]="true" placeholder="Students"
                                (filterChange)="onStudentFilterChange($event)">
                                <ng-template kendoPrefixTemplate>
                                    <button kendoButton [disabled]="true">Students</button>
                                </ng-template>
                                <ng-template kendoMultiSelectTagTemplate let-dataItem>
                                    <span class="template">{{dataItem?.studentName}}</span>
                                </ng-template>
                            </kendo-multiselect>
                        </kendo-label>
                    </kendo-formfield>
                    <!-- <kendo-formfield class="k-w-full" *ngIf="fieldVisibilityConfig.studentsIepMeeting(this)">
                        <kendo-label text="Students" labelCssClass="hidden-label">

                            <kendo-dropdownlist formControlName="students" [data]="studentList" textField="studentName"
                                valueField="nycId" [filterable]="true" placeholder="Students"
                                (filterChange)="onStudentFilterChange($event)">
                                <ng-template kendoDropDownListHeaderTemplate>
                                    <button type="button" kendoButton
                                        class="k-button k-button-solid k-button-solid-base" [disabled]="true">
                                        Students
                                    </button>
                                </ng-template>
                                <ng-template kendoDropDownListItemTemplate let-dataItem>
                                    <span class="template">{{dataItem?.studentName}}</span>
                                </ng-template>
                            </kendo-dropdownlist>
                        </kendo-label>
                    </kendo-formfield> -->
                    <kendo-formfield class="k-w-full" *ngIf="fieldVisibilityConfig.studentsIepMeeting(this)">
                        <kendo-label text="Students" labelCssClass="hidden-label">
                            <kendo-combobox #list [data]="studentList" (filterChange)="onStudentFilterChange($event)" formControlName="students"
                                textField="studentName" [filterable]="true" valueField="nycId">

                                <ng-template kendoComboBoxItemTemplate let-dataItem>
                                    <span class="template">{{dataItem?.studentSK !==
                                        "00000000-0000-0000-0000-000000000000" ? dataItem?.studentName : 'NO DATA
                                        FOUND'}}
                                    </span>
                                </ng-template>
                                <ng-template kendoPrefixTemplate>
                                    <button type="button" kendoButton
                                        class="k-button k-button-solid k-button-solid-base" [disabled]="true">
                                        Students
                                    </button>
                                </ng-template>
                            </kendo-combobox>
                        </kendo-label>

                    </kendo-formfield>
                    <!-- <kendo-formfield class="k-w-full" *ngIf="fieldVisibilityConfig.students(this)">
                    <kendo-label text="Students" labelCssClass="hidden-label">
                        <kendo-textbox placeholder="Students" [allowCustom]="true" formControlName="students">
                            <ng-template kendoTextBoxPrefixTemplate>
                                <button kendoButton [disabled]="true">Students</button>
                            </ng-template>
                            <ng-template kendoMultiSelectTagTemplate let-dataItem>
                                <span class="template">{{dataItem?.name || dataItem }}</span>
                            </ng-template>
                        </kendo-textbox>
                    </kendo-label>
                </kendo-formfield> -->
                    <!-- <kendo-label labelCssClass="hidden-label">
                    <kendo-textbox class="search-container" placeholder="StudentId" formControlName="students"
                        [clearButton]="true">
                        <ng-template kendoTextBoxPrefixTemplate>
 
                        </ng-template> <button kendoButton [disabled]="true">Students</button>
 
 
                    </kendo-textbox>
                </kendo-label> -->

                    <kendo-formfield class="k-w-full required-attendees-field"
                        *ngIf="fieldVisibilityConfig.requiredAttendees(this)">
                        <kendo-label text="required" labelCssClass="hidden-label">
                            <kendo-multiselect placeholder="Required Attendees" [data]="requiredLookupData"
                                [allowCustom]="true" formControlName="requiredAttendees" textField="text"
                                valueField="id" [kendoDropDownFilter]="filterSettings">
                                <ng-template kendoPrefixTemplate>
                                    <button kendoButton [disabled]="true">Required Attendees</button>
                                </ng-template>
                                <ng-template kendoMultiSelectTagTemplate let-dataItem>

                                    <span class="template">{{dataItem?.text || dataItem }}</span>
                                </ng-template>
                            </kendo-multiselect>
                        </kendo-label>
                    </kendo-formfield>
                    <!-- <kendo-formfield class="k-w-full" *ngIf="fieldVisibilityConfig.requiredAttendees(this)">
                        <kendo-label text="Required" labelCssClass="hidden-label">
                            <div class="multiselect-wrapper">
                                <button type="button"
                                    class="k-button k-button-solid k-button-md k-button-solid-base fake-prefix-btn"
                                    disabled>
                                    Required
                                </button>
 
                                <kendo-multiselecttree
                                    placeholder="Search for and select from the list of required attendees for this meeting"
                                    formControlName="requiredAttendees" kendoMultiSelectTreeExpandable
                                    [kendoMultiSelectTreeHierarchyBinding]="requiredLookupData" textField="text"
                                    valueField="id" childrenField="items" kendoMultiSelectTreeExpandable
                                    [checkableSettings]="{ checkChildren: true }" [filterable]="true">
                                    <ng-template kendoMultiSelectTreeTagTemplate let-dataItem>
                                        <ng-container>
                                            {{ dataItem.text }}
                                        </ng-container>
                                    </ng-template>
                                </kendo-multiselecttree>
 
                            </div>
 
                        </kendo-label>
                    </kendo-formfield> -->
                    <kendo-formfield class="k-w-full" *ngIf="fieldVisibilityConfig.optionalAttendees(this)">
                        <kendo-label text="Optional Attendees" labelCssClass="hidden-label">
                            <kendo-multiselect placeholder="Optional Attendees" formControlName="optionalAttendees"
                                [allowCustom]="true" [data]="requiredLookupData" textField="text" valueField="id"
                                [kendoDropDownFilter]="filterSettings">
                                <ng-template kendoPrefixTemplate>
                                    <button kendoButton [disabled]="true">Optional Attendees</button>
                                </ng-template>
                                <ng-template kendoMultiSelectTagTemplate let-dataItem>
                                    <span class="template">{{dataItem?.text || dataItem }}</span>
                                </ng-template>
                            </kendo-multiselect>
                        </kendo-label>
                    </kendo-formfield>
                    <!-- <kendo-formfield class="k-w-full" *ngIf="fieldVisibilityConfig.optionalAttendees(this)">
                        <kendo-label text="Optional Attendees" labelCssClass="hidden-label">
                            <div class="multiselect-wrapper">
                                <button type="button"
                                    class="k-button k-button-solid k-button-md k-button-solid-base fake-prefix-btn"
                                    disabled>
                                    Optional
                                </button>
                                <kendo-multiselecttree
                                    placeholder="Search for and select from the list of optional attendees for this meeting"
                                    formControlName="optionalAttendees" kendoMultiSelectTreeExpandable
                                    [kendoMultiSelectTreeHierarchyBinding]="requiredLookupData" textField="text"
                                    valueField="id" childrenField="items" [checkableSettings]="{ checkChildren: true }"
                                    (valueChange)="onOptionalAttendeesChange($event)" [filterable]="true">
                                    <ng-template kendoMultiSelectTreeTagTemplate let-dataItem>
                                        <span>
                                            {{ dataItem.text }}
                                        </span>
                                    </ng-template>
                                </kendo-multiselecttree>
                            </div>
                        </kendo-label>
                    </kendo-formfield> -->
                    <!-- <kendo-formfield class="k-w-full" *ngIf="fieldVisibilityConfig.requiredAttendees(this)">
                    <kendo-floatinglabel text="Required Attendees">
                        <kendo-multiselecttree placeholder="Required Attendees" formControlName="requiredAttendees"
                            kendoMultiSelectTreeExpandable [kendoMultiSelectTreeHierarchyBinding]="data"
                            textField="text" valueField="id" childrenField="items">
                            <ng-template kendoPrefixTemplate>
                                <button kendoButton [disabled]="true">Required Attendees</button>
                            </ng-template>
                        </kendo-multiselecttree>
                    </kendo-floatinglabel>
                </kendo-formfield>
 
                <kendo-formfield class="k-w-full" *ngIf="fieldVisibilityConfig.optionalAttendees(this)">
                    <kendo-floatinglabel text="Optional Attendees">
                        <kendo-multiselecttree placeholder="Optional Attendees" formControlName="optionalAttendees"
                            kendoMultiSelectTreeExpandable kendoMultiSelectTreeExpandable
                            [kendoMultiSelectTreeHierarchyBinding]="data" textField="text" valueField="id"
                            childrenField="items">
                            <ng-template kendoPrefixTemplate>
                                <button kendoButton [disabled]="true">Optional Attendees</button>
                            </ng-template>
                        </kendo-multiselecttree>
                    </kendo-floatinglabel>
                </kendo-formfield> -->
                </div>
            </div>

            <!------------Location---------------->
            <div class="k-d-flex k-gap-xl k-align-items-center  margin-bottom"
                *ngIf="fieldVisibilityConfig.locationSection(this)">
                <kendo-svg-icon [icon]="locationDot" size="medium"></kendo-svg-icon>
                <div class="k-d-flex k-gap-x-sm k-align-items-center">
                    <kendo-formfield [style.width.px]="160">
                        <kendo-floatinglabel text="Location Type">
                            <kendo-dropdownlist [data]="referenceStore.scheduleLocationType$ | async"
                                [valueField]="'id'" [textField]="'description'" formControlName="locationType"
                                (valueChange)="onLocationTypeChange($event)">
                            </kendo-dropdownlist>
                        </kendo-floatinglabel>
                    </kendo-formfield>

                    <kendo-formfield class="k-mt-5" style="flex: 1;">
                        <kendo-label text="Location" labelCssClass="hidden-label">
                            <kendo-textbox placeholder="Location" formControlName="location" [inputAttributes]="{ 'aria-label': 'Location' }"
                                [maxlength]="120"></kendo-textbox>
                        </kendo-label>
                    </kendo-formfield>
                    <kendo-svg-icon [icon]="stairs" size="medium"
                        class="floor-icon k-d-flex k-align-items-center"></kendo-svg-icon>
                    <kendo-formfield class="k-mt-5" [style.width.px]="263">
                        <kendo-label text="Floor/Room" labelCssClass="hidden-label">
                            <kendo-textbox placeholder="Floor/Room" formControlName="floorRoom" [inputAttributes]="{ 'aria-label': 'Floor/Room' }"
                                [maxlength]="120"></kendo-textbox>
                        </kendo-label>
                    </kendo-formfield>
                </div>
            </div>
            <!----------Teams Meeting Switch------->
            <div class="k-d-flex k-gap-x-sm k-ml-10 k-mb-6" *ngIf="fieldVisibilityConfig.teamsMeeting(this)">
                <kendo-formfield>
                    <div class="k-d-flex k-gap-lg">
                        <kendo-label text="Teams Meeting / Tele" [for]="teamsMeetingSwitch">
                        </kendo-label>
                        <kendo-switch #teamsMeetingSwitch formControlName="teamsMeeting"></kendo-switch>
                    </div>
                </kendo-formfield>
            </div>
            <div class="k-d-flex k-gap-xl k-align-items-center  margin-bottom"
                *ngIf="fieldVisibilityConfig.minutes(this)">
                <kendo-svg-icon [icon]="car" size="medium"></kendo-svg-icon>
                <div>
                    <p class="!k-mt-0">If you are taking transportation to get to this session, please indicate your
                        travel
                        time below.</p>
                    <div class="k-d-flex k-gap-x-lg k-align-items-center">
                        <!-- <kendo-formfield [style.width.px]="160">
                        <kendo-label text="Travel Method" labelCssClass="hidden-label">
                            <kendo-dropdownlist placeholder="Travel Method"
                                formControlName="travelMethod"></kendo-dropdownlist>
                        </kendo-label>
                    </kendo-formfield> -->
                        <!-- <span class="k-d-flex k-align-items-center">for</span> -->
                        <kendo-formfield [style.width.px]="140">
                            <kendo-label text="Minutes" labelCssClass="hidden-label">
                                <kendo-textbox placeholder="#" formControlName="minutes" inputmode="numeric"  [inputAttributes]="{ 'aria-label': 'Minutes' }"
                                    pattern="[0-9]*" (input)="onMinutesInput($event)">
                                    <ng-template kendoTextBoxSuffixTemplate>
                                        <button kendoButton [disabled]="true">minutes</button>
                                    </ng-template>
                                </kendo-textbox>
                            </kendo-label>
                        </kendo-formfield>
                    </div>
                </div>
            </div>
            <div class="k-d-flex k-gap-xl k-align-items-start absence-section-negative-margin"
                *ngIf="showAbsencePeriodForCreate || fieldVisibilityConfig.additionalInformation(this)"
                [class.no-top-gap]="isTimeSpentSessionNotes || isProgressReportingSession || showAbsencePeriodForCreate"
                [class.absence-info-row]="showAbsencePeriodForCreate">
                <span class="absence-icon-container"
                    *ngIf="showAbsencePeriodForCreate || fieldVisibilityConfig.absencePeriod(this)">
                    <kendo-svg-icon [icon]="indent" size="medium"></kendo-svg-icon>
                </span>
                <div class="k-d-grid k-flex-1">
                    <kendo-formfield class="absence-question"
                        *ngIf="showAbsencePeriodForCreate || fieldVisibilityConfig.absencePeriod(this)">
                        <p id="absenceQuestionLabel" class="!k-mb-0 !k-mt-0">If there are scheduled sessions during this time period, the system
                            can
                            mark
                            the
                            encounter service
                            entries as ‘I was absent for this session’ and save the corresponding encounters as drafts
                            or submit them
                            on
                            your
                            behalf. How would you like to proceed?: *</p>
                        <ul class="k-radio-list">
                            <li class="k-radio-item">
                                <input type="radio" #submissionDraft value="draft" kendoRadioButton
                                    formControlName="submission"  aria-labelledby="absenceQuestionLabel submissionDraftLabel submissionDraftDescription"/>

                                <kendo-label [for]="submissionDraft" text="">
                                    <div class="radio-label-container">
                                        <div id="submissionDraftLabel" class="radio-label-main">I want to review and submit each draft
                                            individually.</div>
                                        <div id="submissionDraftDescription" class="radio-label-subtitle">You'll be able to edit or confirm each entry
                                            before submission.</div>
                                    </div>
                                </kendo-label>
                            </li>
                            <li class="k-radio-item">
                                <input type="radio" #submissionImmediate value="submitImmediately" kendoRadioButton
                                    formControlName="submission" aria-labelledby="absenceQuestionLabel submissionImmediateLabel submissionImmediateDescription"  />
                                <kendo-label [for]="submissionImmediate" text="">
                                    <div class="radio-label-container">
                                        <div class="radio-label-main" id="submissionImmediateLabel">Allow the system to submit them all as 'I was
                                            absent for this session' on my behalf.</div>
                                        <div class="radio-label-subtitle" id="submissionImmediateDescription">The system will submit immediately without
                                            further changes.</div>
                                    </div>
                                </kendo-label>
                            </li>
                        </ul>
                    </kendo-formfield>
                    <div class="k-d-flex k-gap-xl k-align-items-flex-start  k-mt-6"
                        *ngIf="!showAbsencePeriodForCreate && fieldVisibilityConfig.additionalInformation(this)">
                        <span class="additional-info-icon-row" *ngIf="!fieldVisibilityConfig.absencePeriod(this)">
                            <kendo-svg-icon [icon]="indent" size="medium"></kendo-svg-icon>
                        </span>
                        <kendo-formfield class="k-w-full">
                            <kendo-label text="Additional Information">
                                <kendo-textarea [rows]="3" placeholder="Type here"
                                    formControlName="additionalInfo"></kendo-textarea>
                            </kendo-label>
                        </kendo-formfield>
                    </div>
                    <kendo-formfield class="k-w-full k-mt-4"
                        *ngIf="showAbsencePeriodForCreate && fieldVisibilityConfig.additionalInformation(this)">
                        <kendo-label text="Additional Information">
                            <kendo-textarea [rows]="3" placeholder="Type here"
                                formControlName="additionalInfo"></kendo-textarea>
                        </kendo-label>
                    </kendo-formfield>

                </div>
            </div>
        </section>
        <div class="k-mt-6" *ngIf="showAuthorizedTraining||showRecordTime">
            <kendo-card width="100%" class="status-cancelled">
                <div class="k-d-flex k-justify-content-between k-align-items-center">
                    <div *ngIf="showAuthorizedTraining">
                        <p class="content !k-mb-0"><strong>Note:</strong> Since the indicated times are in the past, the
                            session details will
                            be saved and certified as both the scheduled and actual service details.
                        </p>
                    </div>
                    <div *ngIf="showAuthorizedTraining">
                        <p class="content !k-mb-0"><strong>Note: You are scheduling an event during a time that has been
                                marked as
                                ‘Provider Absence.’</strong></p>
                        <p> Upon scheduling, the system will automatically mark the associated encounter as ‘Provider
                            Absence’ and submit it on your behalf.
                        </p>
                    </div>
                    <div *ngIf="showRecordTime">
                        <p class="content !k-mb-0 !k-mt-0 k-mx-4">Please note that scheduling this time will only block
                            it
                            on your calendar
                            and mark it as unavailable. Billing will be based on the time you enter for each individual
                            encounter, not the time scheduled here.
                        </p>
                    </div>
                </div>
            </kendo-card>
        </div>
    </div>

</form>

<!-------Note---------->
<div class="note-banner k-d-flex k-mt-4" *ngIf="false">
    <p><strong>Note: </strong>Since the indicated times are in the past, the session details will be saved and certified
        as both the scheduled and actual service details.</p>
    <div class="k-d-grid">
        <strong>Note: You are scheduling an event during a time that has been marked as ‘Provider Absence.’</strong>
        <p>Upon scheduling, the system will automatically mark the associated encounter as ‘Provider Absence’ and submit
            it
            on your behalf.</p>
    </div>
</div>

<kendo-dialog *ngIf="showWarningDialog" [minWidth]="530" [width]="530" [height]="240" id="warning-popup"
    (close)="onStartDateDialogClose()">
    <kendo-dialog-titlebar><kendo-svg-icon [icon]="warningTriangleIcon" [themeColor]="'error'" size="xlarge"
            title="Warning" class="k-mr-3"></kendo-svg-icon>
        Warning</kendo-dialog-titlebar>

    <p class="k-mt-3">
        You selected a <strong>Start Date before today</strong>.
        <br />
        Are you sure you want to proceed?
    </p>

    <kendo-dialog-actions>
        <button kendoButton themeColor="primary" fillMode="solid" (click)="confirmPastStartDate()">
            Yes
        </button>

        <button kendoButton fillMode="flat" themeColor="error" (click)="onStartDateDialogClose()">
            No
        </button>
    </kendo-dialog-actions>
</kendo-dialog>
